import { sfVideoPlayer } from './video-player.component';

export default angular
  .module('sfMobile.components.video-player', [
    'sfMobile.services.digital-assets',
  ])
  .component('sfVideoPlayer', sfVideoPlayer).name;
